<template>
  <CalendarField
    :label="translate(`${LOCALE_PREFIX}.form.tenders.tenderSetup.rates.startTime`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.tenders.tenderSetup.rates.startTimePlaceholder`)"
    :id="`tender-start-time-${index}`"
    :inputId="`tender-start-time-${index}`"
    :name="fieldName"
    timeOnly
    hourFormat="12"
    :stepMinute="15"
    :required="true"
    :baseZIndex="9999"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../../enums';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;
</script>
